export const getInNetwork = (plan, name) =>
  plan.benefits
    ?.find((v) => v.name === name)
    ?.cost_sharings?.find((v) => v.network_tier === "In-Network")
    ?.display_string

export const getDisplay = (v) => {
  const l = { "No Charge After Deductible": "D Free", "No Charge": "Free" }
  if (l[v]) return l[v]
  let r
  r = /(\d+%) coinsurance after deductible/i.exec(v)
  if (r) {
    return `D ${r[1]}`
  }
  r = /(\$\d+) copay after deductible/i.exec(v)
  if (r) {
    return `D ${r[1]}`
  }
  return v
}

export const getBackground = (v) => {
  const l = {
    "No Charge After Deductible": "#87C93644",
    "No Charge": "#1DE23744",
  }
  if (l[v]) return l[v]
  let r
  r = /(\d+%) coinsurance after deductible/i.exec(v)
  if (r) {
    return `#BDCE3144`
  }
  r = /(\$\d+) copay after deductible/i.exec(v)
  if (r) {
    return `#9CCE3144`
  }
  return undefined
}
